import { GoStarFill } from 'react-icons/go'
import { formatDistanceToNow } from 'date-fns'
import moment from 'moment'
import 'moment/locale/ar-kw'
import { ar } from 'date-fns/locale'
import toast from 'react-hot-toast'

const datetimeFormat = (date, format = 'LLLL') => {
  return moment(date).format(format)
}

function datetimeAgo(date) {
  return formatDistanceToNow(moment(date), {
    addSuffix: true,
    locale: ar,
  })
}

function toastError(message) {
  toast.custom((t) => (
    <div
      className={`${t.visible ? 'animate-enter' : 'animate-leave'} pointer-events-auto relative flex w-full max-w-md border-2 border-danger-600 bg-danger-100 text-sm text-danger-600 shadow-md`}
    >
      <div className="absolute flex h-2 w-full bg-danger-600"></div>
      <div className="flex flex-col gap-1 p-2 pt-4">
        <h3 className="font-bold">خطأ</h3>
        <p>{message}</p>
      </div>
    </div>
  ))
}

function toastSuccess(message) {
  toast.custom((t) => (
    <div
      className={`${t.visible ? 'animate-enter' : 'animate-leave'} pointer-events-auto relative flex w-full max-w-md border-2 border-success-600 bg-success-100 text-sm text-success-600 shadow-md`}
    >
      <div className="absolute flex h-2 w-full bg-success-600"></div>
      <div className="flex flex-col gap-1 p-2 pt-4">
        <h3 className="font-bold">إشعار</h3>
        <p>{message}</p>
      </div>
    </div>
  ))
}

export { toastSuccess, toastError, datetimeFormat, datetimeAgo }
